import { Button, Modal, Radio, message } from "antd";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  allDiaries,
  saveAllDiaries,
  saveArchiveModalOpen,
  saveDiaryStatus,
} from "redux/diaries/diariesSlice";

export default function ArchiveConversation({
  isArchiveConversationModalOpen,
}) {
  const dispatch = useDispatch();
  const [archiveStatus, setArchiveStatus] = useState(null);
  const diaries = useSelector(allDiaries);
  const [btnLoading, setbtnLoading] = useState(false);

  const onChange = (e) => {
    setArchiveStatus(e?.target?.value);
  };

  const close = () => {
    dispatch(saveArchiveModalOpen({ flag: false, diaryId: null }));
    setArchiveStatus(null);
  };

  const archiveJournal = async () => {
    try {
      setbtnLoading(true);
      const body = {
        diaryId: isArchiveConversationModalOpen?.diaryId,
        action: 1,
        archiveReason: archiveStatus,
      };
      const res = await NetworkCall.fetch(
        Request.archiveUnArchiveJournal(body)
      );
      message.success(res?.message);
      let temp = [...diaries];
      const index = temp?.findIndex(
        (e) => e?.diaryId === isArchiveConversationModalOpen?.diaryId
      );
      temp[index] = {
        ...temp[index],
        isArchiveOrUnarchiveRequester: true,
        status: {
          ...temp[index]?.status,
          id: 6,
          name: "PendingToArchive",
        },
      };
      dispatch(saveDiaryStatus({ diary: temp[index] }));
      dispatch(saveAllDiaries(temp));
      close();
      setbtnLoading(false);
    } catch (error) {
      setbtnLoading(false);
    }
  };
  return (
    <Modal
      className="archive-conversation-modal"
      centered
      title="Archive Journal"
      open={isArchiveConversationModalOpen?.flag}
      onOk={close}
      onCancel={close}
      closeIcon={<i className="icon-close"></i>}
      footer={[
        <Button
          className="done-btn"
          type="primary"
          disabled={!!!archiveStatus}
          onClick={archiveJournal}
          loading={btnLoading}
        >
          Proceed
        </Button>,
      ]}
    >
      <Radio.Group defaultValue="b" onChange={onChange} value={archiveStatus}>
        <Radio.Button value="Issue Resolved">
          <div className="option-wrap">
            <span className="option">A</span> <span>Issue Resolved</span>
          </div>
        </Radio.Button>
        <Radio.Button value="Agreed to disagree but moving forward">
          <div className="option-wrap">
            <span className="option">B</span>{" "}
            <span>Agreed to disagree but moving forward</span>
          </div>
        </Radio.Button>
        <Radio.Button value="I no longer want to discuss this issue">
          <div className="option-wrap">
            <span className="option">C</span>{" "}
            <span>I no longer want to discuss this issue</span>
          </div>
        </Radio.Button>
      </Radio.Group>
    </Modal>
  );
}
